<section
  class="question-paper-shell flex min-h-screen flex-col overflow-visible rounded-sm border border-slate-300 bg-white lg:h-full lg:min-h-0 lg:overflow-hidden"
>
  @if (popupMode()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
      <article class="w-full max-w-lg overflow-hidden rounded-xl bg-white shadow-xl">
        @if (popupMode() === 'time-expired') {
          <div class="flex items-center gap-2 bg-red-600 px-5 py-3">
            <img [src]="imageEnum.INFO_WHITE" alt="info.svg" />
            <h2 class="secondary-label font-inter font-semibold text-white">Time Expired</h2>
          </div>

          <div class="px-6 py-8 text-center sm:px-8">
            <p class="text-lg font-semibold text-text-primary font-inter">
              Your Examination time has expired.
            </p>
            <p class="mt-2 text-sm font-medium text-slate-500 font-inter">
              Your responses are being submitted automatically.
            </p>

            <div class="mt-6 flex flex-col items-center justify-center gap-3">
              <div class="time-expired-loader" aria-hidden="true">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        } @else if (popupMode() === 'section-time-locked') {
          <div class="flex items-center gap-2 bg-brand-primary px-5 py-3">
            <img [src]="imageEnum.INFO_WHITE" alt="info.svg" />
            <h2 class="secondary-label font-inter font-semibold text-white">Cannot Move Forward</h2>
          </div>

          <div class="px-6 py-8 text-center sm:px-8">
            <p class="text-lg font-semibold text-text-primary font-inter">
              You cannot move forward because the time left is not fulfilled.
            </p>
            <p class="mt-2 text-sm font-medium text-slate-500 font-inter">
              Please wait for this section's allotted time to complete before moving to the next
              section. Your response has been saved.
            </p>

            <div class="mt-6 flex justify-center">
              <app-primary-button
                text="Okay"
                buttonClass="rounded-xl px-6 py-2 text-sm font-medium"
                ariaLabel="Close cannot move forward popup"
                (buttonClick)="closePopup()"
              />
            </div>
          </div>
        } @else {
          <div class="flex items-center justify-between bg-[#D32F2F] px-5 py-3">
            <h2 class="text-base font-bold text-white">Exit Examination</h2>
            <button
              type="button"
              class="text-xl font-bold text-white transition hover:opacity-80"
              aria-label="Close exit popup"
              (click)="resumeFullScreen()"
            >
              ×
            </button>
          </div>

          <div class="px-6 py-6 sm:px-8">
            <p class="text-base font-bold text-text-primary text-left">
              Are you sure you want to exit the examination?
            </p>
            <p class="mt-2 text-sm text-[#D32F2F] text-left">
              Warning: Your progress is saved. You can resume this test later from the dashboard, but only within the total allotted time.
            </p>

            <hr class="my-6 border-slate-200" />

            <div class="flex w-full justify-center gap-4">
              <div class="w-1/2">
                <app-outline-button
                  text="Exit Examination"
                  buttonClass="w-full rounded-md !border-[#D32F2F] px-4 py-2.5 text-sm font-bold tracking-normal !text-[#D32F2F] hover:bg-red-50 active:bg-red-100"
                  ariaLabel="Exit exam flow"
                  (buttonClick)="exitToTestSeries()"
                />
              </div>
              <div class="w-1/2">
                <app-primary-button
                  text="Stay in Examination"
                  buttonClass="w-full rounded-md px-4 py-2.5 text-sm font-bold tracking-normal !bg-[#3B5998] !bg-none hover:opacity-95 active:opacity-90 border-0"
                  ariaLabel="Stay in Examination"
                  (buttonClick)="resumeFullScreen()"
                />
              </div>
            </div>
          </div>
        }
      </article>
    </div>
  }

  @if (isViolationSubmitOpen()) {
    <div class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4">
      <article
        class="w-full max-w-lg overflow-hidden rounded-xl bg-white shadow-xl"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="violation-submit-title"
      >
        <div class="flex items-center gap-2 bg-red-600 px-5 py-3">
          <img [src]="imageEnum.INFO_WHITE" alt="info.svg" />
          <h2 id="violation-submit-title" class="secondary-label font-inter font-semibold text-white">
            Exam Submitted for Review
          </h2>
        </div>

        <div class="px-6 py-8 text-center sm:px-8">
          <p class="text-base font-semibold leading-7 text-text-primary font-inter">
            Due to a security violation, we are submitting this exam for review. Once the results are officially
            announced, the same exam will be uploaded as a practice test for reference and preparation.
          </p>

          <div class="mt-6 flex justify-center">
            <app-primary-button
              text="Okay"
              buttonClass="rounded-xl px-6 py-2 text-sm font-medium"
              ariaLabel="Close security violation popup"
              [disabled]="!canCloseViolationSubmit()"
              (buttonClick)="closeViolationSubmit()"
            />
          </div>
        </div>
      </article>
    </div>
  }

  @if (proctoringWarning(); as warning) {
    <div class="fixed inset-0 z-[55] flex items-center justify-center bg-black/40 px-4">
      <article
        #proctoringWarningDialog
        class="flex max-h-[calc(100dvh-2rem)] w-full max-w-lg flex-col overflow-hidden rounded-xl bg-white shadow-xl"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="proctoring-warning-title"
      >
        <div
          class="flex shrink-0 items-center gap-2 px-5 py-3"
          [class.bg-red-600]="warning.violationCount === proctoringFirstWarning"
          [class.bg-amber-500]="warning.violationCount !== proctoringFirstWarning"
        >
          <img [src]="imageEnum.INFO_WHITE" alt="info.svg" />
          <h2 id="proctoring-warning-title" class="secondary-label font-inter font-semibold text-white">
            Proctoring Warning ({{ warning.violationCount }}{{
              proctoringViolationLimit() ? ' of ' + proctoringViolationLimit() : ''
            }})
          </h2>
        </div>

        <div class="min-h-0 overflow-y-auto px-6 py-6 sm:px-8">
          <p class="text-center text-base font-semibold leading-7 text-text-primary font-inter">
            {{ warning.message }}
          </p>

          @if (warning.current; as current) {
            <section
              class="mt-5 rounded-lg border px-4 py-3 text-left font-inter"
              [class.border-red-200]="warning.violationCount === proctoringFirstWarning"
              [class.bg-red-50]="warning.violationCount === proctoringFirstWarning"
              [class.border-amber-200]="warning.violationCount !== proctoringFirstWarning"
              [class.bg-amber-50]="warning.violationCount !== proctoringFirstWarning"
            >
              <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-600">Current violation</h3>
              <div class="mt-1 flex items-baseline justify-between gap-3">
                <p class="text-sm font-semibold text-text-primary">{{ current.eventType | titleCase }}</p>
                <time class="shrink-0 text-xs text-slate-600" [attr.datetime]="current.timestamp">
                  {{ current.timestamp | date: 'h:mm:ss a' }}
                </time>
              </div>
              <p class="mt-0.5 text-sm text-slate-600">{{ current.message }}</p>
            </section>
          }

          @if (warning.previous.length) {
            <section class="mt-4 text-left font-inter">
              <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-600">
                Previous violations ({{ warning.previous.length }})
              </h3>
              <ol class="mt-2 max-h-48 divide-y divide-slate-100 overflow-y-auto rounded-lg border border-slate-200">
                @for (violation of warning.previous; track $index) {
                  <li class="px-4 py-2">
                    <div class="flex items-baseline justify-between gap-3">
                      <p class="text-sm font-medium text-text-primary">{{ violation.eventType | titleCase }}</p>
                      <time class="shrink-0 text-xs text-slate-600" [attr.datetime]="violation.timestamp">
                        {{ violation.timestamp | date: 'h:mm:ss a' }}
                      </time>
                    </div>
                    <p class="text-xs text-slate-600">{{ violation.message }}</p>
                  </li>
                }
              </ol>
            </section>
          }

          <div class="mt-6 flex justify-center">
            <app-primary-button
              text="Okay"
              buttonClass="rounded-xl px-6 py-2 text-sm font-medium"
              ariaLabel="Close proctoring warning"
              (buttonClick)="closeProctoringWarning()"
            />
          </div>
        </div>
      </article>
    </div>
  }

  @if (isTimeWarningOpen()) {
    <div class="fixed inset-0 z-40 flex items-center justify-center bg-black/25 px-4">
      <article class="w-full max-w-md overflow-hidden rounded-xl bg-white shadow-xl">
        <div class="flex items-center gap-2 bg-amber-500 px-5 py-3">
          <img [src]="imageEnum.INFO_WHITE" alt="info.svg" />
          <h2 class="secondary-label font-inter font-semibold text-white">Time Reminder</h2>
        </div>

        <div class="px-6 py-6 sm:px-8">
          <p class="text-base font-semibold text-text-primary font-inter">
            {{ timeWarningLabel() }} in {{ activePart()?.label }}.
          </p>
          <p class="mt-2 text-sm font-medium leading-6 text-slate-500 font-inter">
            Please review your current response and use Save and Next if you want this answer to be counted.
          </p>

          <div class="mt-5 flex justify-end">
            <app-primary-button
              text="Okay"
              buttonClass="rounded-xl px-5 py-2 text-sm font-medium"
              ariaLabel="Close time warning"
              (buttonClick)="closeTimeWarning()"
            />
          </div>
        </div>
      </article>
    </div>
  }


  @if (activePart(); as part) {
    <app-question-paper-popup
      [isOpen]="contentPopupMode() !== null"
      [mode]="contentPopupMode()"
      [activePartLabel]="part.label"
      [popupHeading]="popupHeading()"
      [questions]="activePartQuestions()"
      [instructionIntroItems]="instructionIntroItems()"
      [instructionSections]="instructionPopupSections()"
      [paletteLegend]="instructionLegend"
      (close)="closeContentPopup()"
    />
  }

  <app-submit-examination-details-popup
    [isOpen]="isSubmitPopupOpen()"
    [totalQuestions]="totalQuestionCount()"
    [answeredCount]="totalAnsweredCount()"
    [notAnsweredCount]="totalNotAnsweredCount()"
    [markedForReviewCount]="totalMarkedForReviewCount()"
    [notVisitedCount]="totalNotVisitedCount()"
    (close)="closeSubmitPopup()"
    (submit)="submitExam()"
  />

  <header
    class="flex flex-col border-b border-slate-300 bg-brand-secondary text-white lg:flex-row lg:items-center lg:justify-between"
  >
    <div class="flex w-full flex-wrap items-center justify-end gap-4 px-4 py-3 text-sm">
      <button
        type="button"
        class="flex items-center gap-2 transition hover:opacity-85"
        aria-label="Open question paper popup"
        (click)="openContentPopup('question-paper')"
      >
        <svg class="h-4 w-4" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M6.66699 3.33333H10.8337L14.167 6.66667V15.8333C14.167 16.2936 13.7939 16.6667 13.3337 16.6667H6.66699C6.20676 16.6667 5.83366 16.2936 5.83366 15.8333V4.16667C5.83366 3.70643 6.20676 3.33333 6.66699 3.33333Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
          <path
            d="M10.833 3.33333V6.66667H14.1663"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
        </svg>
        <span class="font-medium">Question Paper</span>
      </button>

      <button
        type="button"
        class="flex items-center gap-2 transition hover:opacity-85"
        aria-label="Open instructions popup"
        (click)="openContentPopup('instructions')"
      >
        <svg class="h-4 w-4" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M10 13.3333V10"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
          />
          <path
            d="M10 6.66666H10.0083"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
          />
          <path
            d="M16.6663 10C16.6663 13.6819 13.6816 16.6667 9.99967 16.6667C6.31778 16.6667 3.33301 13.6819 3.33301 10C3.33301 6.3181 6.31778 3.33333 9.99967 3.33333C13.6816 3.33333 16.6663 6.3181 16.6663 10Z"
            stroke="currentColor"
            stroke-width="1.5"
          />
        </svg>
        <span class="font-medium">Instructions</span>
      </button>
    </div>
  </header>

  @if (activePart(); as part) {
  @if (activeQuestion(); as question) {
  <div class="flex min-h-0 flex-1 flex-col lg:flex-row">
    <div
      data-exam-content
      class="question-main-column relative flex flex-1 flex-col overflow-hidden border-r-0 border-slate-300 lg:min-h-0 lg:h-full lg:border-r"
    >
      @if (preparedState()?.settings?.enableCalculator) {
        <app-calculator-widget />
      }
      @if (preparedState()?.settings?.enableMagnifier) {
        <app-magnifier-widget (activeChange)="onMagnifierToggled($event)" />
      }

      <div class="border-b border-slate-300 bg-slate-50 px-4 pt-3">
        <div class="flex flex-wrap items-end gap-2">
          @for (part of parts(); track part.id; let index = $index) {
            <button
              type="button"
              class="flex h-9 items-center gap-1 rounded-t-lg border px-4 text-sm transition disabled:cursor-not-allowed disabled:opacity-60"
              [class.bg-brand-primary]="activePart()?.label === part.label"
              [class.text-white]="activePart()?.label === part.label"
              [class.border-brand-primary]="activePart()?.label === part.label"
              [class.bg-white]="activePart()?.label !== part.label"
              [class.border-blue-200]="activePart()?.label !== part.label"
              [class.text-brand-primary]="activePart()?.label !== part.label"
              [disabled]="isPartDisabled(index)"
              (click)="selectPart(index)"
              (mouseenter)="showPartHoverPopup($event, part.label)"
              (mouseleave)="hidePartHoverPopup()"
            >
              <span>{{ part.label }}</span>
              <img
                [src]="
                  activePart()?.label === part.label ? imageEnum.INFO_WHITE : imageEnum.INFO_BLUE
                "
                alt=""
                class="h-3.5 w-3.5"
              />
            </button>
          }
        </div>
      </div>

      @if (hoveredPartLabel(); as hoveredPart) {
        <div
          class="fixed z-50 w-64 max-w-[calc(100vw-1rem)] rounded-lg border border-slate-200 bg-white p-3 shadow-lg"
          [style.top.px]="hoverPopupPosition().top"
          [style.left.px]="hoverPopupPosition().left"
        >
          <p class="text-sm font-semibold text-text-primary">{{ hoveredPart }}</p>
          @if (getPartOverview(hoveredPart); as overview) {
            <p class="mb-2 text-xs text-slate-500">
              {{ overview.order }} of {{ parts().length }} · {{ overview.info }} ·
              {{ overview.durationInMinutes }} min
            </p>
          } @else {
            <div class="mb-2"></div>
          }
          <div class="grid grid-cols-2 gap-x-3 gap-y-2 text-xs leading-4 text-slate-700">
            <div class="question-legend-row">
              <span class="question-legend-tile">
                <span
                  class="flex items-center justify-center text-xs font-bold leading-none text-white"
                  [class]="getLegendShapeClasses('answered')"
                  >{{ getPartStats(hoveredPart).answered }}</span
                >
              </span>
              <span>Answered</span>
            </div>
            <div class="question-legend-row">
              <span class="question-legend-tile">
                <span
                  class="flex items-center justify-center text-xs font-bold leading-none text-white"
                  [class]="getLegendShapeClasses('not-answered')"
                  >{{ getPartStats(hoveredPart).notAnswered }}</span
                >
              </span>
              <span>Not Answered</span>
            </div>
            <div class="question-legend-row">
              <span class="question-legend-tile">
                <span
                  class="flex items-center justify-center text-xs font-bold leading-none text-text-primary"
                  [class]="getLegendShapeClasses('not-visited')"
                  >{{ getPartStats(hoveredPart).notVisited }}</span
                >
              </span>
              <span>Not Visited</span>
            </div>
            <div class="question-legend-row">
              <span class="question-legend-tile">
                <span
                  class="flex items-center justify-center text-xs font-bold leading-none text-white"
                  [class]="getLegendShapeClasses('marked')"
                  >{{ getPartStats(hoveredPart).marked }}</span
                >
              </span>
              <span>Marked for Review</span>
            </div>
            <div class="question-legend-row col-span-2 items-start">
              <span class="question-legend-tile">
                <span
                  class="flex items-center justify-center text-xs font-bold leading-none text-white"
                  [class]="getLegendShapeClasses('marked-answered')"
                  >{{ getPartStats(hoveredPart).markedAnswered }}</span
                >
              </span>
              <span>Answered & Marked for Review</span>
            </div>
          </div>
        </div>
      }

      <div
        class="flex flex-wrap items-center justify-between gap-3 border-b border-slate-300 px-4 py-3"
      >
        <p class="text-lg font-medium text-text-primary">
          Current Section : {{ part.label }}
        </p>
        <p class="text-lg font-semibold"
           [class.text-text-primary]="partTimeLeftInSeconds() > 60"
           [class.text-red-600]="partTimeLeftInSeconds() <= 60"
           [class.animate-pulse]="partTimeLeftInSeconds() <= 60">Time Left: {{ timeLeft() }}</p>
      </div>

      <div class="border-b border-slate-300 px-4 py-3">
        <p class="text-base font-semibold text-red-600">
          Question Type : {{ question.type }}
        </p>
      </div>

      <div class="border-b border-slate-300 px-4 py-3">
        <p class="text-base font-semibold text-text-primary">
          Question No : {{ activeQuestionIndex() + 1 }}
        </p>
      </div>

      <div class="question-content-scroll min-h-0 flex-1 overflow-y-auto" appMockTestSecureContent>
        <div class="px-4 py-5">
          <div class="label-small-heading question-prompt-html text-slate-700" [innerHTML]="question.prompt | richHtml"></div>

          @for (image of question.media; track image.src) {
            <figure class="question-media-panel mt-6 px-3">
              <img
                [src]="image.src"
                [alt]="image.alt"
                class="question-image question-media-image" />

              @if (image.caption) {
                <figcaption class="question-media-caption">
                  {{ image.caption }}
                </figcaption>
              }
            </figure>
          }

          <fieldset class="mt-6 space-y-4 px-3">
            <legend class="sr-only">Answer options</legend>

            @for (option of question.options; track option.id) {
              <div class="flex items-start gap-3">
                <input
                  type="radio"
                  class="mt-1 h-4 w-4 border-slate-400 text-brand-primary focus:ring-brand-primary"
                  [name]="'question-' + question.id"
                  [checked]="isOptionSelected(question.id, option.id)"
                  (change)="selectAnswer(question.id, option.id)"
                />
                <span class="label-small-heading flex min-w-0 gap-1 leading-6 text-slate-700">
                  <span class="shrink-0">{{ option.label }}.</span>
                  <span class="question-prompt-html min-w-0" [innerHTML]="option.text | richHtml"></span>
                </span>
              </div>
            }
          </fieldset>

          <!-- @if (question.isGuessingAllowed) { -->
            <div class="mt-8 flex items-center gap-3 text-slate-700">
              <input
                type="checkbox"
                class="h-4 w-4 rounded border-slate-400 text-brand-primary focus:ring-brand-primary"
                [checked]="isGuessing(question.id)"
                (click)="toggleGuessing($event)"
              />
              <span class="label-small-heading">I am guessing this</span>
              <div class="group relative flex items-center justify-center">
                <button
                  type="button"
                  class="inline-flex h-5 w-5 cursor-default items-center justify-center text-sky-400 transition hover:text-brand-primary"
                  aria-label="Guess tracker information"
                >
                  <img [src]="imageEnum.INFO_BLUE" alt="info.svg" class="mt-0.5" />
                </button>

                <div class="pointer-events-none invisible absolute bottom-full left-1/2 z-50 mb-2 w-72 -translate-x-1/2 opacity-0 transition-all duration-200 group-hover:visible group-hover:opacity-100">
                  <div class="rounded-xl border border-indigo-100 bg-white px-4 py-3 text-xs leading-5 text-slate-600 shadow-xl">
                    <p class="mb-1 text-sm font-semibold text-brand-primary">Introducing Guess Tracker</p>
                    New feature to help you with negative marking! While taking a test, you can now mark the questions you are guessing. Review them later in the rank screen to know your net score and performance from guessing.

                    <div class="absolute -bottom-2 left-1/2 -translate-x-1/2 border-8 border-transparent border-t-white drop-shadow-md"></div>
                  </div>
                </div>
              </div>
            </div>
          <!-- } -->
        </div>
      </div>

      <div
        class="mt-auto flex flex-col gap-3 border-t border-slate-300 bg-white px-4 py-3 lg:flex-row lg:items-center lg:justify-between"
      >
        <div class="flex flex-wrap gap-3">
          <button
            type="button"
            class="h-10 rounded-md border border-slate-300 bg-white px-4 text-sm font-medium text-text-primary transition hover:bg-slate-50"
            (click)="markForReviewAndNext()"
          >
            Mark for Review & Next
          </button>

          <button
            type="button"
            class="h-10 rounded-md border border-slate-300 bg-white px-4 text-sm font-medium text-text-primary transition hover:bg-slate-50"
            (click)="clearResponse()"
          >
            Clear Response
          </button>
        </div>

        <div class="flex flex-wrap gap-3">
          <button
            type="button"
            class="h-10 rounded-md bg-mock-indigo-900 px-6 text-sm font-medium text-white transition disabled:cursor-not-allowed disabled:opacity-50"
            (click)="saveAndNext()">
            {{ isLastQuestionOfSection() ? 'Save' : 'Save and Next' }}
          </button>
        </div>
      </div>
    </div>

    <aside
      class="question-sidebar flex min-h-0 h-full w-full shrink-0 flex-col border-t border-slate-300 bg-white lg:border-t-0"
    >
      <div class="flex items-center gap-3 border-b border-slate-300 px-4 py-4">
        <div
          class="flex h-12 w-12 items-center justify-center rounded bg-brand-secondary text-3xl font-semibold text-white"
        >
          {{ candidateInitials() }}
        </div>
        <div>
          <p class="text-xl font-semibold leading-6 text-[#435ba0]">{{ candidateDisplayName() }}</p>
        </div>
      </div>

      <div
        class="grid grid-cols-2 gap-x-4 gap-y-3 border-b border-slate-300 px-4 py-4 text-[15px] leading-5 text-slate-700"
      >
        <div class="question-legend-row">
          <span class="question-legend-tile">
            <span
              class="flex items-center justify-center text-[15px] font-bold leading-none text-white"
              [class]="getLegendShapeClasses('answered')"
              >{{ answeredCount() }}</span
            >
          </span>
          <span>Answered</span>
        </div>
        <div class="question-legend-row">
          <span class="question-legend-tile">
            <span
              class="flex items-center justify-center text-[15px] font-bold leading-none text-white"
              [class]="getLegendShapeClasses('not-answered')"
              >{{ notAnsweredCount() }}</span
            >
          </span>
          <span>Not Answered</span>
        </div>
        <div class="question-legend-row">
          <span class="question-legend-tile">
            <span
              class="flex items-center justify-center text-[15px] font-bold leading-none text-text-primary"
              [class]="getLegendShapeClasses('not-visited')"
              >{{ notVisitedCount() }}</span
            >
          </span>
          <span>Not Visited</span>
        </div>
        <div class="question-legend-row">
          <span class="question-legend-tile">
            <span
              class="flex items-center justify-center text-[15px] font-bold leading-none text-white"
              [class]="getLegendShapeClasses('marked')"
              >{{ markedCount() }}</span
            >
          </span>
          <span>Marked for Review</span>
        </div>
        <div class="question-legend-row col-span-2 items-start">
          <span class="question-legend-tile">
            <span
              class="flex items-center justify-center text-[15px] font-bold leading-none text-white"
              [class]="getLegendShapeClasses('marked-answered')"
              >{{ markedAnsweredCount() }}</span
            >
          </span>
          <span>Answered & Marked for Review (will be considered for evaluation)</span>
        </div>
      </div>

      <div class="border-b border-slate-300 bg-mock-teal-600 px-2 py-1.5">
        <p class="text-base font-bold font-inter text-white">{{ part.label }}</p>
      </div>

      <div class="question-sidebar-scroll min-h-0 flex-1 overflow-y-auto bg-[#f8f8f8] px-4 py-4">
        <p class="text-base font-semibold text-text-primary">Choose a Question</p>

        <div class="mt-4 grid grid-cols-5 gap-3">
          @for (question of activePartQuestions(); track question.id; let index = $index) {
            <button
              type="button"
              class="question-palette-button transition"
              [class.question-palette-button-active]="isCurrentQuestion(question.id)"
              (click)="setActiveQuestion(index)"
            >
              <span
                class="question-palette-chip flex items-center justify-center text-base font-semibold leading-none text-mock-gray-900"
                [class]="getPaletteClasses(question.id)"
              >
                {{ index + 1 }}
              </span>
            </button>
          }
        </div>
      </div>

      <div class="mt-auto border-t border-slate-300 bg-white px-4 py-3">
        <!-- <button
          type="button"
          class="mx-auto block h-10 w-28 rounded-md bg-[#8f95ea] text-sm font-semibold text-white transition disabled:cursor-not-allowed disabled:bg-slate-300 hover:bg-[#7f86e2]"
          [disabled]="!canSubmit()"
          (click)="submitExam()">
          Submit
        </button> -->
        <app-primary-button
          type="button"
          text="Submit"
          buttonClass="w-full text-sm font-medium h-10"
          ariaLabel="Start selected test"
          [disabled]="!canSubmit()"
          (buttonClick)="openSubmitPopup()"
        />
      </div>
    </aside>
  </div>
  }
  }
</section>
